import { useState, useRef } from 'react'
import { PhotoIcon } from '@heroicons/react/24/outline';
import { fileSize } from 'components/misc/functions';
import imageCompression from 'browser-image-compression';

function PhotoVerify({ label, name, value, setValue }) {

    const [preview, setPreview] = useState(null);
    const handleFileInput = useRef(null);

    const handleClick = () => {
        handleFileInput.current.click();
    }

    const handleImageSet = async(e) => {
        const file = e.target.files[0];
        const options = {
            maxSizeMB: 1,
            useWebWorker: true
        }

        const compressedImage = await imageCompression(file, options);
        const renamedImage = new File([compressedImage], `${name}.jpg`, { type: compressedImage.type });
        setValue(renamedImage);

        // Preview image
        if(file){
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setPreview(reader.result);
            }
        }
    }

    return (
        <>
        <div className="col-span-full">
            <p className="form-label">
                {label} 
            </p>
            <div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 dark:border-white px-6 py-10">
                <div className="text-center">
                    {preview === null ? (
                        <PhotoIcon className="mx-auto h-12 w-12 text-gray-300" aria-hidden="true" />
                        ) : (
                        <img src={preview} alt={`${name} of GhanaCard`} className='w-72 object-fit object-cover mx-auto' />
                    )}
                    <div className="mt-4 flex flex-col items-center justify-center text-sm leading-6 text-gray-600">
                        {/* <p className="relative cursor-pointer rounded-md font-semibold text-slate-700 dark:text-slate-600 hover:text-gold-500 px-3 py-1.5 bg-slate-100">
                            <button type="button" onClick={handleClick}>
                                {value === "" ? "Take a photo" : "Change photo"}
                            </button>
                        </p> */}
                        <p className="relative cursor-pointer rounded-md font-semibold text-slate-700 dark:text-slate-600 hover:text-gold-500 px-3 py-1.5 bg-slate-100">
                            <span onClick={handleClick} className="cursor-pointer">
                                {value === "" ? "Take a photo" : "Change photo"}
                            </span>
                        </p>

                        {value && (
                            <p className='min-w-[50%] max-w-auto mx-auto mt-5 text-xs truncate dark:text-slate-400'>
                                {value.name} - {fileSize(value.size)}
                            </p>
                        )}
                    </div>
                </div>
            </div>

            <input ref={handleFileInput} className="hidden" type="file" accept="image/*" capture={name === "selfie-photo" ? "user" : "environment"} onChange={handleImageSet} />
            
            {name === "selfie-photo" &&
                <p className="px-3 py-1.5 bg-slate-100 text-slate-700 text-center text-sm mt-3 rounded-md">
                    Please make sure your face is 90% of the view finder of the camera and you are in a bright environment with your face well lit.
                </p>
            }
        </div>
        </>
    )
}

export default PhotoVerify